/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { useLazyQuery, gql } from '@apollo/client';

const FETCH_STORE_CONFIG_VALUES = gql`
    query Configuration($inputKeys: [String!]!) {
      configuration(inputKeys: $inputKeys) {
        name
        value
      }
    }
`;
export const  useGetStoreConfigValues =  () => {
  const [getStoreConfigDetails, storeConfigDetail] = useLazyQuery(FETCH_STORE_CONFIG_VALUES,{context:{clientName:"config"}});
  return { getStoreConfigDetails, storeConfigDetail };
};
